/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter/types';
import { delayedResponse, makeMockResponse } from '../mockUtils';
import { CashboxesByStoreTypesDto } from './statisticsClient.typings';
import { cashboxesByActivityDtoFactory, cashBoxesStatisticsFactory } from './statisticsFactories';

export function addStatisticsMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onGet(/statistics\/cashBoxes$/).reply((config) => {
        const data = cashBoxesStatisticsFactory.item();
        return delayedResponse(makeMockResponse(200, data, config), 2000);
    });

    //TODO remove
    mockAdapter.onGet(/statistics\/cashBoxes\/byStoreTypes/).reply((config) => {
        const data: CashboxesByStoreTypesDto = {
            storeTypes: cashboxesByActivityDtoFactory.list({ count: 20 }),
            timeOfLastUpdate: null, //`${new Date().toISOString()}`,//'2020-02-02T11:27:11.996063',
        };

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 100);
    });
}
